import BasePagination from "./BasePagination.vue";
export default BasePagination;
